import { render, staticRenderFns } from "./SelectUsers.vue?vue&type=template&id=23bc5b20&scoped=true"
import script from "./SelectUsers.vue?vue&type=script&lang=js"
export * from "./SelectUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bc5b20",
  null
  
)

export default component.exports